
export enum ActivityState {
	ToDo = 'To Do',
	InProgress = 'In Progress',
	Complete = 'Complete',
	Overdue = 'Overdue'
}
